export const USERNAME_COLORS = [
  { id: 'default', label: 'Default', elite: false, className: 'text-primary' },
  { id: 'gold', label: 'Gold', elite: true, className: 'text-amber-300' },
  { id: 'crimson', label: 'Crimson', elite: true, className: 'text-rose-400' },
  { id: 'azure', label: 'Azure', elite: true, className: 'text-sky-400' },
  { id: 'emerald', label: 'Emerald', elite: true, className: 'text-emerald-400' },
  { id: 'violet', label: 'Violet', elite: true, className: 'text-violet-400' },
  {
    id: 'rainbow', label: 'Rainbow', elite: true,
    className: 'bg-gradient-to-r from-rose-400 via-amber-300 via-emerald-400 to-sky-400 bg-clip-text text-transparent font-medium'
  },
  {
    id: 'sunset', label: 'Sunset', elite: true,
    className: 'bg-gradient-to-r from-amber-300 via-orange-400 to-rose-500 bg-clip-text text-transparent font-medium'
  },
  {
    id: 'aurora', label: 'Aurora', elite: true,
    className: 'bg-gradient-to-r from-emerald-300 via-teal-300 to-violet-400 bg-clip-text text-transparent font-medium'
  },
  {
    id: 'ocean', label: 'Ocean', elite: true,
    className: 'bg-gradient-to-r from-sky-300 via-cyan-300 to-indigo-400 bg-clip-text text-transparent font-medium'
  }
];

export const usernameColorClass = (color) =>
  USERNAME_COLORS.find((c) => c.id === (color || 'default'))?.className || 'text-primary';
